import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    spirotech_user_agreement_part1: {
      id: 'spirotech_user_agreement_part1',
      defaultMessage: "I consent to having my personal data contained in the registration form processed as stated in the posted",
      description: '',
    },
    spirotech_user_agreement_part2: {
      id: 'spirotech_user_agreement_part2',
      defaultMessage: " privacy statement",
      description: '',
    },
    spirotech_privacy_introduce_part1: {
      id: 'spirotech_privacy_introduce_part1',
      defaultMessage: "The controller of your personal data, provided by you during registration on the website: https://i-connect.spirotech.com (hereinafter “Website”), is Husty M.Styczeń, J.Hupert sp. j. (hereinafter “Husty”).",
      description: '',
    },
    spirotech_privacy_introduce_part2: {
      id: 'spirotech_privacy_introduce_part2',
      defaultMessage: "Husty takes the protection of your privacy very seriously. We therefore handle your personal data confidentially and with the greatest possible care.",
      description: '',
    },
    spirotech_privacy_introduce_part3: {
      id: 'spirotech_privacy_introduce_part3',
      defaultMessage: "This Privacy Policy applies to all personal data that are collected and used by Husty. These data are customer data provided by you, but also data concerning visits to the Website.",
      description: '',
    },
    spirotech_privacy_introduce_part4: {
      id: 'spirotech_privacy_introduce_part4',
      defaultMessage: "Husty only uses your data if you consent or if Husty needs your data to deliver products or services to you or has already done so. Husty does not sell your personal data to third parties. Husty only makes the data available to third parties involved in the performance of the agreement between Husty and yourself. If and when Husty processes your data in any other way, such will require your (express) consent.",
      description: '',
    },
    spirotech_privacy_contact_part1: {
      id: 'spirotech_privacy_contact_part1',
      defaultMessage: "Our contact details are:",
      description: '',
    },
    spirotech_privacy_contact_part2: {
      id: 'spirotech_privacy_contact_part2',
      defaultMessage: "HUSTY M. Styczeń, J.Hupert sp.j.",
      description: '',
    },
    spirotech_privacy_contact_part3: {
      id: 'spirotech_privacy_contact_part3',
      defaultMessage: "ul.Rzepakowa 5E",
      description: '',
    },
    spirotech_privacy_contact_part4: {
      id: 'spirotech_privacy_contact_part4',
      defaultMessage: "31-989 Kraków, Poland",
      description: '',
    },
    spirotech_privacy_point_1_text: {
      id: 'spirotech_privacy_point_1_text',
      defaultMessage: "General",
      description: '',
    },
    spirotech_privacy_point_1: {
      id: 'spirotech_privacy_point_1',
      defaultMessage: "The protection of your personal data is very important to us. That is why we comply strictly with the rules that apply to data protection as well as telemedia legislation. Our employees commit that they will comply with the data protection regulations when handling your personal data. We wish to inform you by means of this privacy statement of the nature, scope and purpose of the collection, processing and use of personal data, as well as your rights. The term personal data is defined in the EU General Data Protection Regulation (GDPR). According to this regulation, personal data concerns all information with respect to an identified or identifiable natural person. This includes for example your name, your address, your telephone number and your e-mail address",
      description: '',
    },
    spirotech_privacy_point_2_text: {
      id: 'spirotech_privacy_point_2_text',
      defaultMessage: "Collection, processing and use of personal data",
      description: '',
    },
    spirotech_privacy_point_2: {
      id: 'spirotech_privacy_point_2',
      defaultMessage: "Husty collects, processes and uses personal data insofar as the EU GDPR or another statutory provision permits or requires this or if the person involved has consented thereto. We wish to inform you that providing personal data such as name, surname and e-mail address is voluntary, but necessary to register in our service. The legal basis for processing the personal data is article 6 (1)(a) EU GDPR. We refer to the fact that unencrypted data transfer on the internet, such as communication by e-mail, may result in security issues. Complete protection of the data against third-party access is impossible.",
      description: '',
    },
    spirotech_privacy_point_3_text: {
      id: 'spirotech_privacy_point_3_text',
      defaultMessage: "Transfer of data to third parties",
      description: '',
    },
    spirotech_privacy_point_3: {
      id: 'spirotech_privacy_point_3',
      defaultMessage: "Husty does not sell or provide your personal data to third parties and only makes these data available to third parties that are involved in the provision of the agreed services. Our employees and hired third parties are obliged to respect the confidentiality of your data. We wish to inform you that we do not transfer your personal data outside the EU.",
      description: '',
    },
    spirotech_privacy_point_4_text: {
      id: 'spirotech_privacy_point_4_text',
      defaultMessage: "Data retention",
      description: '',
    },
    spirotech_privacy_point_4: {
      id: 'spirotech_privacy_point_4',
      defaultMessage: "Husty retains your personal data for as long as this is necessary to provide our services. If you decide to stop using our services, we will remove your personal data at your request. Please bear in mind that a copy of these data may be stored in back-ups.",
      description: '',
    },
    spirotech_privacy_point_5_text: {
      id: 'spirotech_privacy_point_5_text',
      defaultMessage: "Information, correction and objection",
      description: '',
    },
    spirotech_privacy_point_5: {
      id: 'spirotech_privacy_point_5',
      defaultMessage: "You have the right to request information concerning the personal data stored by us and to have these corrected or removed. What is more, you can withdraw your consent to future use of your data at any time or request that your data be transferred to another provider. An e-mail to the following address is sufficient: info@husty.com. You also have the right to submit a complaint to the supervising data protection authority.",
      description: '',
    },
    spirotech_privacy_point_6_text: {
      id: 'spirotech_privacy_point_6_text',
      defaultMessage: "Changes to this Privacy Policy",
      description: '',
    },
    spirotech_privacy_point_6: {
      id: 'spirotech_privacy_point_6',
      defaultMessage: "This Privacy Policy may be updated as a result of changes to the applicable legislation or as a result of changes within our business or our services. We will announce any adjustments via this page. We therefore recommend that you read the Privacy Policy regularly in order to stay informed. In the event we implement changes that have a significant impact on you, we will inform you thereof by sending an e-mail message or via our services for example.",
      description: '',
    },
    spirotech_cookie_part_1_text: {
      id: 'spirotech_cookie_part_1_text',
      defaultMessage: "Cookie Statement",
      description: '',
    },
    spirotech_cookie_part_1: {
      id: 'spirotech_cookie_part_1',
      defaultMessage: "The Website, as a part of domain: https://www.spirotech.com/, is the property of Spirotech bv (hereinafter “Spirotech”). The Website uses cookies. A cookie is a text file that is sent when visiting a website as a visitor and that is stored in the cache of the hard drive of your computer. The browser of your computer sends the cookie received previously back to the server if you as a visitor to the website connect again to the relevant server of the website. If this is the case, the server will be able to evaluate the information obtained by means of this procedure in various ways. Cookies may be used to send advertisements or facilitate navigation to a website for example. If you as the user of the website wish to prevent cookies from being used, you can realise this by changing the local browser settings, which means in the program on the device for opening and showing websites (such as Internet Explorer, Mozilla Firefox, Chrome or Safari).",
      description: '',
    },
    spirotech_cookie_part_1a: {
      id: 'spirotech_cookie_part_1a',
      defaultMessage: "The Website uses the following three types of cookies:",
      description: '',
    },
    spirotech_cookie_part_2_text: {
      id: 'spirotech_cookie_part_2_text',
      defaultMessage: "Functional and necessary cookies",
      description: '',
    },
    spirotech_cookie_part_2: {
      id: 'spirotech_cookie_part_2',
      defaultMessage: "Some cookies are necessary for the correct operation of The Website. We use these cookies to store your preferences. These are cookies that are used to recognise you as soon as you have registered. This means that you do not have to enter your username and/or password each time you visit The Website and we will be certain that you have the right to visit and modify secure areas of The Website such as your personal data.",
      description: '',
    },
    spirotech_cookie_part_3_text: {
      id: 'spirotech_cookie_part_3_text',
      defaultMessage: "Social media and external cookies",
      description: '',
    },
    spirotech_cookie_part_3: {
      id: 'spirotech_cookie_part_3',
      defaultMessage: "ou can make use of additional functionalities if you have logged into social network sites (Facebook, Google, etc.) and have consented to this category of cookies on the The Website. These functionalities include the simple sharing of information via Facebook Like, Google+, Twitter etc. Review the policy of the social media companies for the cookies they place and the possible data they collect when doing so. Bear in mind that this policy may change on a regular basis. This is beyond Husty’s control.",
      description: '',
    },
    spirotech_cookie_part_4_text: {
      id: 'spirotech_cookie_part_4_text',
      defaultMessage: "Optimisation and relevance of cookies",
      description: '',
    },
    spirotech_cookie_part_4: {
      id: 'spirotech_cookie_part_4',
      defaultMessage: "We also use cookies to collect information. This information shows us which pages are visited most often, which pages work well, and which pages display error messages. We use this information to improve the ease of use of The Website.",
      description: '',
    },
    spirotech_cookie_part_5_text: {
      id: 'spirotech_cookie_part_5_text',
      defaultMessage: "Google Analytics",
      description: '',
    },
    spirotech_cookie_part_5: {
      id: 'spirotech_cookie_part_5',
      defaultMessage: "The Website also uses Analytics cookies placed by Google Analytics to measure the number of visits and the sections of the website that are most popular among the visitors to the website. This information is used for aggregated and statistical information concerning the use of our website and is used to improve the content of our website for a better user experience. The Website also uses Analytics cookies to measure your experience of our website and to be able to measures the effectiveness of e-mail campaigns, advertisements of Adwords on other, third-party websites. Husty uses Google Analytics in a privacy-friendly manner. Among other things, Spirotech as the owner of the domain, concluded a processing agreement that obliges Google Analytics to use data exclusively for the abovementioned analysis purposes, to remove the last 4 digits of your IP address and to oblige Google to use the data separately from their other services.",
      description: '',
    },
    husty_user_agreement: {
      id: 'husty_user_agreement',
      defaultMessage: "I consent to having my personal data contained in the registration form of SaoCal  water treatment system Internet service processed by Husty M.Styczeń, J.Hupert sp. j. registered in Krakow [ul. Rzepakowa 5E, 31-989 Kraków, entered in the Register of Entrepreneurs kept by the District Court for Kraków-Śródmieście District in Krakow, 9th Commercial Department of the National Court Register, entry no. KRS 91562, Tax ID No. NIP 6770082043, Business Statistical No. REGON 350690189] for the purpose and to the extent required to complete the registration process in the service and operate the account created in the service.",
      description: '',
    },
    husty_privacy_point_1: {
      id: 'husty_privacy_point_1',
      defaultMessage: "Your personal data administrator is Husty M.Styczeń, J.Hupert sp. j. registered in Krakow [ul. Rzepakowa 5E, 31-989 Kraków, entered in the Register of Entrepreneurs kept by the District Court for Kraków-Śródmieście District in Krakow, 9th Commercial Department of the National Court Register, entry no. KRS 91562, Tax ID No. NIP 6770082043, Business Statistical No. REGON 350690189 (“the Administrator”)]; the Administrator’s contact details: info@husty.pl  Tel. +48(012) 645-03-04; fax +48(012) 645-03-33.",
      description: '',
    },
    husty_privacy_point_2: {
      id: 'husty_privacy_point_2',
      defaultMessage: "The Administrator has not appointed the Personal Data Protection Inspector.",
      description: '',
    },
    husty_privacy_point_3: {
      id: 'husty_privacy_point_3',
      defaultMessage: "Be informed that your personal data is processed for the purpose of registration in the Internet Service for SaoCal water treatment systems and for the purpose of keeping your account created in the Service. Your email address given during your registration in the Service is required, in particular, to log into the Service and recover your lost or forgotten password. Furthermore, notifications about devices linked  to your account shall be emailed to your email address.",
      description: '',
    },
    husty_privacy_point_4: {
      id: 'husty_privacy_point_4',
      defaultMessage: "Your personal data is processed on the basis of your voluntarily given consent, constituting the premise legalising personal data processing in accordance with the provisions of art. 6 item 1a of the Regulation (EU) on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (General Data Protection Regulation - the GDPR).",
      description: '',
    },
    husty_privacy_point_5: {
      id: 'husty_privacy_point_5',
      defaultMessage: "It is a contractual requirement to have your personal data in the Internet Service. You are not obligated to enter or otherwise give us your personal data; however, it is not possible to register in the Internet Service operated for SaoCal water treatment systems without entering your personal data.",
      description: '',
    },
    husty_privacy_point_6: {
      id: 'husty_privacy_point_6',
      defaultMessage: "Your personal data entered in the registration form shall be transferred to hosting companies responsible for ensuring appropriate and adequate technological and organisational measures in place as required by the GDPR. Neither the Administrator nor the hosting companies working with the Administrator shall hand over, transfer or otherwise make your data available to any third countries (i.e. any countries outside the European Union).",
      description: '',
    },
    husty_privacy_point_7: {
      id: 'husty_privacy_point_7',
      defaultMessage: "Your personal data shall be kept for the duration of your keeping your account in the Internet Service for the SaoCal water treatment system and removed without a delay after your account is closed or removed.",
      description: '',
    },
    husty_privacy_point_8: {
      id: 'husty_privacy_point_8',
      defaultMessage: "Be informed that you have the right to:",
      description: '',
    },
    husty_privacy_point_8_a: {
      id: 'husty_privacy_point_8_a',
      defaultMessage: "request access to your personal data from the Administrator;",
      description: '',
    },
    husty_privacy_point_8_b: {
      id: 'husty_privacy_point_8_b',
      defaultMessage: "when the personal data processed by the Administrator is incorrect, you have the right to correct, change, amend or modify it;",
      description: '',
    },
    husty_privacy_point_8_c: {
      id: 'husty_privacy_point_8_c',
      defaultMessage: "in the case when the Administrator does not need your personal data for the purpose for which it has been collected as well as when the data should be removed to comply with applicable laws or the data has been collected further to provision of services offered electronically to a child, you have the right to request removal of your personal data by the Administrator;",
      description: '',
    },
    husty_privacy_point_8_d: {
      id: 'husty_privacy_point_8_d',
      defaultMessage: "in case when you question correctness of the personal data processed by the Administrator, you may request to have its processing limited for the period allowing the Administrator to verify correctness of the data;",
      description: '',
    },
    husty_privacy_point_8_e: {
      id: 'husty_privacy_point_8_e',
      defaultMessage: "except for the case specified in let. d) above, you have the right to limiting personal data processing when the personal data is unlawfully processed by the Administrator but you refuse to have it removed or when the Administrator does not need your personal data for the purpose of its processing but you need the data for the purpose of pursuing claims or defence.",
      description: '',
    },
    husty_privacy_point_8_f: {
      id: 'husty_privacy_point_8_f',
      defaultMessage: "to request a transfer of you personal data which you may specify.",
      description: '',
    },
    field_max_length_25: {
      id: 'field_max_length_25',
      defaultMessage: "Field must be a maximum 25 characters length",
      description: '',
    },
    husty_cookie_part_1: {
      id: 'husty_cookie_part_1',
      defaultMessage: "Cookies files are IT data, in particular text files, kept in the end device of the Service User and designated for using the Service websites. Typically, cookies include the name of the website of their origin, the period/duration of their keeping on the end device and their unique number.",
      description: '',
    },
    husty_cookie_part_2: {
      id: 'husty_cookie_part_2',
      defaultMessage: "The entity introducing and storing cookies on the end device of the Service User and having access to the cookies is HUSTY, registered in Krakow, ul.Rzepakowa 5E, 31-989 Kraków",
      description: '',
    },
    husty_cookie_part_3: {
      id: 'husty_cookie_part_3',
      defaultMessage: "Cookies are used for the purpose of collecting information about the use the Service by the User. In particular, cookies make it possible:",
      description: '',
    },
    husty_cookie_part_3_1: {
      id: 'husty_cookie_part_3_1',
      defaultMessage: "To keep a session of the Service User (once logged in) open - the User does not need to log into each Service page again by entering his login and password;",
      description: '',
    },
    husty_cookie_part_3_2: {
      id: 'husty_cookie_part_3_2',
      defaultMessage: "Adapt the content of the Service website to the User’s preferences and optimise the use of websites; in particular, the files allow for identifying the User’s device and display the website in the right display mode as needed by the User;",
      description: '',
    },
    husty_cookie_part_3_3: {
      id: 'husty_cookie_part_3_3',
      defaultMessage: "To generate the statistics helpful in understanding the pattern of website browsing and using by the Service User in order to improve its structure and content.",
      description: '',
    },
    husty_cookie_part_4: {
      id: 'husty_cookie_part_4',
      defaultMessage: "Two basic types of cookies are used in the Service: session cookies and persistent cookies. Session cookies are temporary files stored in the end device of the Service User until they log out leaving the website or shutting down the software (the Internet browser). Persistent cookies are stored in the User’s end device for the time specified in the parameters of the cookies or until they are removed by the User.",
      description: '',
    },
    husty_cookie_part_5: {
      id: 'husty_cookie_part_5',
      defaultMessage: "The following types of cookies are used in the Service:",
      description: '',
    },
    husty_cookie_part_5_1: {
      id: 'husty_cookie_part_5_1',
      defaultMessage: "“necessary” cookies which make it possible to use services available in the Service e.g. authenticated the cookies used for services which require authentication in the Service;",
      description: '',
    },
    husty_cookie_part_5_2: {
      id: 'husty_cookie_part_5_2',
      defaultMessage: "“performance” cookies which make it possible to collect information on the Service websites are used.",
      description: '',
    },
    husty_cookie_part_5_3: {
      id: 'husty_cookie_part_5_3',
      defaultMessage: "“functional” cookies which make it possible to “remember” the settings selected by the User and personalise the User interface.",
      description: '',
    },
    husty_cookie_part_6: {
      id: 'husty_cookie_part_6',
      defaultMessage: "In many cases, the web search software (a web browser), by default, allows for storing cookies in the User’s end device. Service Users may change their cookies settings at any time. In particular, the settings may be changed to block the automatic servicing of the cookies in the Internet browser settings or the Service User is notified about each attempt to add/ insert cookies to their devices. For more information about cookies, their operation and service methods check your Internet software (browser) settings.",
      description: '',
    },
    husty_cookie_part_7: {
      id: 'husty_cookie_part_7',
      defaultMessage: "Be informed that limitations in the application of cookies may affect certain functionalities available on the Service websites.",
      description: '',
    },
    husty_cookie_part_8: {
      id: 'husty_cookie_part_8',
      defaultMessage: "For more information about cookies, see wszystkoociasteczkach.pl or clik Help section in your Internet browser menu.",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPages/Messages.js